var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"pt-20 pb-20"},[_c('svg',{staticClass:"spinner",attrs:{"width":"65px","height":"65px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }